
export default function AppFooter() {
    return (
        <div className="">
            <div className="flex gap-2 text-700 text-xs align-items-end">
                <div className="flex">
                    <img src='/img/csx_logo.png' alt="logo" className="h-4rem w-auto"/>
                </div>
                <div className="flex flex-column">
                    <div className="line-height-1">
                        <p>CSX Building, St. Preah Mohaksat Treiyani Kossamak (St.106), Sangkat Wat Phnom, Khan Daun Penh, Phnom Penh, Kingdom of Cambodia.</p>
                        <p>Office Phone: (+855) 23 958 888 | Fax: (+855) 23 955 558 | E-mail: info@csx.com.kh</p>
                        <p className="mb-0">Copy Right © 2012 Cambodia Securties Exchange (CSX) - All Right Reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}